import { Befehl } from '../models'
import {
  findAuftrag,
  hasField,
  hasFieldContent,
  hasEitherFieldContent
} from './helpers'

/**
 * Checks if Befehl 9 has empty fields.
 *
 * Specific business rules:
 * - 9.42.1 km/h is optional
 * - Location type: 9.43 alone = "in", 9.43+9.44 = "zwischen"
 * - von/bis distance fields required when location type chosen
 * - Each distance needs either km OR signal (not both required)
 * - 9.67, 9.68, 9.70, 9.75 are simple boolean aufträge without fields
 *
 * NOTE: Does not use generic check due to complex either/or field logic.
 *
 * Aufträge without felder are never considered to have empty fields.
 * Boolean field values are never considered empty fields.
 */
export function hasBefehl9EmptyFields(befehl: Befehl): boolean {
  if (!befehl?.auftraege?.length) return false
  // Check specific business rules
  const auftrag940 = findAuftrag(befehl, '9.40')

  if (!auftrag940) {
    return false
  }

  const has943 = hasField(auftrag940, '9.43')
  const has944 = hasField(auftrag940, '9.44')
  const hasSelectorFields = has943 || has944

  if (auftrag940 && !hasSelectorFields) {
    return true // if neither "zwischen" nor "in" have been selected
  }

  // If selector fields are present, 9.43 must have content
  if (
    hasSelectorFields &&
    (!hasFieldContent(auftrag940, '9.43', 'zugmeldestelle.name') ||
      !hasFieldContent(auftrag940, '9.43', 'zugmeldestelle.art'))
  ) {
    return true
  }

  // If 9.44 exists, it must have content (zwischen mode)
  if (
    has944 &&
    (!hasFieldContent(auftrag940, '9.44', 'zugmeldestelle.name') ||
      !hasFieldContent(auftrag940, '9.44', 'zugmeldestelle.art'))
  ) {
    return true
  }

  // If selector fields are present, von (9.47) must have either km or signal
  if (
    hasSelectorFields &&
    !hasEitherFieldContent(auftrag940, '9.47.1', 'km', '9.47.2', 'signal')
  ) {
    return true
  }

  // If selector fields are present, bis (9.48) must have either km or signal
  if (
    hasSelectorFields &&
    !hasEitherFieldContent(auftrag940, '9.48.1', 'km', '9.48.2', 'signal')
  ) {
    return true
  }

  return false
}
